import styles from "./PrivacyPolicy.styles";
import { useI18n } from "../../i18n";
import Seo from "../../components/Seo";

export default function PrivacyPolicy() {
  const { t } = useI18n();
  return (
    <div className={`${styles.container}`}>
      <Seo title={t("seo_privacy_title")} description={t("seo_privacy_desc")} />
      <h1>{t("privacy_title")}</h1>
      <h4>{t("privacy_effective")}</h4>
      <p>
        This Privacy Policy applies to Zilouet, its associated subdomains, and
        its mobile application (collectively referred to as the “Service”). By
        accessing or using any part of Zilouet’s Service, you confirm that you
        have read, understood, and agree to the collection, storage, use, and
        disclosure of your personal information as described in this Privacy
        Policy and our Terms of Service.
      </p>
      <h3>{t("privacy_definitions")}</h3>
      <p>
        {t("privacy_definitions_intro")}
        <ul>
          <li>
            <strong>{t("privacy_def_cookie")}</strong> A small data file generated by a website
            and stored in your browser. It helps identify your browser, provide
            analytics, and remember preferences like language or login
            information.
          </li>
          <li>
            <strong>{t("privacy_def_company")}</strong> When this policy mentions
            &ldquo;Company,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or
            &ldquo;our,&rdquo; it refers to Zilouet, responsible for your
            personal information under this Privacy Policy.
          </li>
          <li>
            <strong>{t("privacy_def_country")}</strong> Refers to the country where Zilouet is
            based.
          </li>
          <li>
            <strong>{t("privacy_def_customer")}</strong> Refers to the company, organization, or
            individual that signs up to use Zilouet&apos;s services.
          </li>
          <li>
            <strong>{t("privacy_def_device")}</strong> Any internet-connected device such as a
            phone, tablet, computer, or similar device used to access the
            Service.&nbsp;
          </li>
          <li>
            <strong>{t("privacy_def_ip")}</strong> A unique address assigned to each
            device connected to the internet, often used to determine location.
          </li>
          <li>
            <strong>{t("privacy_def_personnel")}</strong> Individuals employed or contracted to
            perform a service on behalf of Zilouet.
          </li>
          <li>
            <strong>{t("privacy_def_data")}</strong> Any information that directly or
            indirectly identifies a natural person.
          </li>
          <li>
            <strong>{t("privacy_def_service")}</strong> Refers to the services provided by
            Zilouet, as described in this Privacy Policy and on our platform.
          </li>
          <li>
            <strong>{t("privacy_def_third_party")}</strong> Refers to advertisers,
            marketing partners, or other companies whose content or services we
            believe may be of interest to you.
          </li>
        </ul>
      </p>
      <h3>{t("privacy_data_collection")}</h3>
      <p>
        When you visit or interact with Zilouet&rsquo;s platform, we
        automatically collect certain information, including:
        <ul>
          <li>
            <strong>{t("privacy_device_info")}</strong> IP address, browser type,
            operating system, language preferences, and time zone.
          </li>
          <li>
            <strong>{t("privacy_usage_info")}</strong> Pages visited, time spent on the
            site, and actions taken (e.g., clicks or scrolls).
          </li>
          <li>
            <strong>{t("privacy_cookies_analytics")}</strong> We use cookies and similar
            technologies to enhance functionality, analyze traffic, and prevent
            fraud.
          </li>
        </ul>
        This information does not reveal your personal identity but helps
        maintain the security and operation of our platform.
      </p>
      <h3>{t("privacy_affiliates")}</h3>
      <p>
        We may share your personal data with corporate affiliates, meaning
        entities that control, are controlled by, or are under common control
        with Zilouet. These affiliates will treat your information in accordance
        with this Privacy Policy.
      </p>
      <h3>{t("privacy_consent")}</h3>
      <p>
        By using Zilouet’s platform, creating an account, or making a purchase,
        you consent to our Privacy Policy and its terms.
      </p>
      <h3>{t("privacy_cookies")}</h3>
      <p>
        We use cookies to identify areas of the site that you have visited and
        improve your experience. You can disable cookies in your browser
        settings, though some functionality (like videos or login persistence)
        may be affected.
      </p>
      <h3>{t("privacy_changes")}</h3>
      <p>
        We may update this Privacy Policy to reflect changes in our services or
        policies. We will notify you of any significant changes and provide an
        opportunity to review the updated policy before it becomes effective.
        Continued use of Zilouet’s services after such updates constitutes your
        acceptance of the revised policy.{" "}
      </p>
      <h3>{t("privacy_third_party")}</h3>
      <p>
        Our platform may contain links to third-party content or services. We
        are not responsible for the accuracy, legality, or quality of
        third-party services. Your use of them is at your own risk and subject
        to the third party’s terms.
      </p>
      <h3>{t("privacy_contact")}</h3>
      <p>{t("privacy_contact_body")}</p>
    </div>
  );
}
